(() => {
  'use strict';
  const modal = document.querySelector('[data-pre-checkout-upsell]');
  const engine = window.KickisUpsellEngine;
  if (!modal || modal.dataset.enabled !== 'true' || !engine || !window.KickisUpsellLoader) return;
  const root = window.Shopify?.routes?.root || '/';
  const grid = modal.querySelector('.pre-checkout-upsell__grid');
  const status = modal.querySelector('[data-upsell-status]');
  const continueButton = modal.querySelector('[data-upsell-continue]');
  const rotateButton = modal.querySelector('[data-upsell-rotate]');
  const picker = modal.querySelector('[data-upsell-picker]');
  const pickerList = picker.querySelector('[data-upsell-options]');
  const pickerSearch = picker.querySelector('input[type="search"]');
  const pickerStatus = picker.querySelector('[data-upsell-picker-status]');
  const pickerAdd = picker.querySelector('[data-upsell-picker-add]');
  const checkoutSelector = 'button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout';
  const mobileQuery = matchMedia('(max-width: 749px)');
  let generation = 0, busy = false, cart = null, products = [], currentProduct = null, opener = null, pickerOpener = null;
  let selected = new Map(), shownOptions = 40, previous = [], lastSignature = '', skipSignature = '', uncertain = false;
  const impressions = new Set();
  try { previous = JSON.parse(sessionStorage.getItem('kickis-upsell-previous') || '[]'); } catch (_) { /* Storage is optional. */ }
  if (!Array.isArray(previous)) previous = [];
  const signature = window.KickisUpsellLoader.signature;
  let seed = Math.floor(Math.random() * 1e9), warmTimer = null, cartRequest = null, cartVersion = 0, moreSuggestions = false;
  const preloaded = new Set();
  let storage; try { storage = window.sessionStorage; } catch (_) { /* Optional. */ }
  const loader = window.KickisUpsellLoader.create({engine, json, rootPath: root, storage,
    scope: `${window.Shopify?.theme?.id}:${root}:${window.Shopify?.currency?.active}:${window.Shopify?.country || ''}`,
    preload: source => {
      const src = safeImage(source); if (!src || preloaded.has(src)) return;
      preloaded.add(src); if (preloaded.size > 40) preloaded.delete(preloaded.values().next().value);
      const image = new Image(); image.decoding = 'async'; image.fetchPriority = 'low'; image.src = src;
      image.decode?.().catch(() => {});
    }
  });
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', {style: 'currency', currency: cart?.currency || window.Shopify?.currency?.active || 'SEK', maximumFractionDigits: 0, minimumFractionDigits: 0}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeImage = value => /^(https:\/\/|\/\/)/.test(value || '') ? value : '';
  const url = p => `${root}products/${encodeURIComponent(p.handle)}`;
  async function json(path, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), options.method ? 20000 : 10000);
    try {
      const response = await fetch(path, {credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal});
      const data = await response.json();
      if (!response.ok) throw Error(data.description || 'Kunde inte hämta aktuella uppgifter.');
      return data;
    } finally { clearTimeout(timeout); }
  }
  const detail = p => json(`${url(p)}?view=kickis-upsell-data&_=${Date.now()}`);
  function readCart() {
    if (!cartRequest) {
      const request = json(`${root}cart.js`).then(value => {
        if (!Array.isArray(value.items) || !Number.isFinite(value.item_count)) throw Error('Invalid cart');
        return value;
      }).finally(() => { if (cartRequest === request) cartRequest = null; });
      cartRequest = request;
    }
    return cartRequest;
  }
  function warm() {
    if (document.hidden || busy || navigator.connection?.saveData) return;
    const version = cartVersion;
    readCart().then(value => {
      if (version !== cartVersion) return;
      return loader.prepare(value, {seed, previous});
    }).catch(() => {}); // Optional work never blocks browsing or checkout.
  }
  function scheduleWarm() {
    clearTimeout(warmTimer);
    warmTimer = setTimeout(() => {
      if (window.requestIdleCallback) window.requestIdleCallback(warm, {timeout: 1000});
      else warm();
    }, 180);
  }
  function cartChanged() {
    cartVersion++; cartRequest = null; loader.invalidate(); skipSignature = '';
    ++generation;
    // The add flow already reconciles its own cart; don't interrupt its picker/focus.
    if (busy) return;
    products = [];
    if (picker.open) picker.close();
    if (!modal.hidden) refresh(); else scheduleWarm();
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, cartChanged);
  document.addEventListener('cart:refresh', cartChanged);
  window.addEventListener('pageshow', e => { if (e.persisted) { loader.clearStock(); cartChanged(); } });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { loader.clearStock(); cartChanged(); } });
  document.addEventListener('pointerover', e => { if (e.target.closest(checkoutSelector)) scheduleWarm(); }, {passive: true});
  document.addEventListener('focusin', e => { if (e.target.closest(checkoutSelector)) scheduleWarm(); });
  scheduleWarm();
  function analytics(type, p, variant, quantity) {
    document.dispatchEvent(new CustomEvent('kickis:analytics:event', {detail: {
      eventType: type, itemType: 'product', itemKey: `product:${p.id}`, itemTitle: p.title,
      itemUrl: url(p), imageUrl: p.image || '', variantKey: String(variant?.id || ''),
      quantity, value: variant ? variant.price / 100 * (quantity || 1) : undefined,
      metadata: {recommendationContext: 'pre_checkout', recommendationVersion: 3, reason: p.category, recommendationGroup: p.group || 'accessory'}
    }}));
  }
  function setBusy(value) {
    busy = value;
    modal.querySelectorAll('button').forEach(b => { b.disabled = value; });
    if (!value) { pickerAdd.disabled = selected.size === 0 || uncertain; rotateButton.disabled = uncertain; }
  }
  function renderCards() {
    const limit = Math.min(mobileQuery.matches ? 6 : 8, Math.max(1, Number(mobileQuery.matches ? modal.dataset.mobileProductLimit : modal.dataset.desktopProductLimit) || (mobileQuery.matches ? 6 : 8)));
    const visible = engine.select(products, limit);
    const card = p => {
      const price = Math.min(...p.variants.map(v => v.price)) * (p.cm ? 100 : 1);
      const count = p.variantCount > 1 ? `${p.variantCount} varianter · ${p.variants.length} tillgängliga${['needle','hook'].includes(p.category) ? ' i passande storlek' : ''}` : 'I lager';
      return `<article class="pre-checkout-upsell-card" data-upsell-card data-handle="${escape(p.handle)}" data-group="${p.group === 'inspiration' ? 'inspiration' : 'accessory'}">
        <a class="pre-checkout-upsell-card__image-link" href="${url(p)}">${p.image ? `<img class="pre-checkout-upsell-card__image" src="${escape(safeImage(p.image))}" alt="${escape(p.title)}" width="220" height="220" loading="eager" decoding="async">` : ''}</a>
        <div class="pre-checkout-upsell-card__body"><p class="pre-checkout-upsell-card__vendor">${escape(p.vendor)}</p>
        <h4 class="pre-checkout-upsell-card__title"><a href="${url(p)}">${escape(p.title)}</a></h4>
        <p class="pre-checkout-upsell-card__meta pre-checkout-upsell-card__price">${p.variants.some(v => v.price !== p.variants[0].price) ? 'Från ' : ''}${money(price)}${p.cm ? ' / m' : ''}</p>
        <p class="pre-checkout-upsell-card__meta pre-checkout-upsell-card__count" title="${escape(count)}"><span class="pre-checkout-upsell-card__count-full">${escape(count)}</span><span class="pre-checkout-upsell-card__count-short" aria-hidden="true">${p.variantCount > 1 ? `${p.variantCount} varianter` : 'I lager'}</span></p><p class="pre-checkout-upsell-card__meta pre-checkout-upsell-card__reason">${escape(p.reason)}</p>
        <button type="button" class="button button--secondary pre-checkout-upsell-card__button" data-upsell-choose>${p.variantCount > 1 ? 'Välj alternativ' : 'Lägg i varukorgen'}</button></div></article>`;
    };
    grid.innerHTML = [['accessory', 'Tillbehör till ditt projekt'], ['inspiration', 'Populärt i butiken']].map(([group, title]) => {
      const items = visible.filter(p => (p.group || 'accessory') === group);
      if (!items.length) return '';
      return `<section class="pre-checkout-upsell__group" data-upsell-group="${group}" style="--upsell-columns:${Math.ceil(items.length / 2)}" aria-labelledby="UpsellGroup-${group}">
        <h3 id="UpsellGroup-${group}" class="pre-checkout-upsell__group-heading">${title}</h3>
        <div class="pre-checkout-upsell__group-grid">${items.map(card).join('')}</div></section>`;
    }).join('');
    visible.forEach(p => { if (!impressions.has(p.handle)) { analytics('upsell_viewed', p); impressions.add(p.handle); } });
    previous = visible.map(p => p.handle);
    try { sessionStorage.setItem('kickis-upsell-previous', JSON.stringify(previous)); } catch (_) { /* No storage required. */ }
    rotateButton.hidden = !moreSuggestions && products.length <= visible.length;
  }
  const applyResponsiveCardLimit = () => { if (!modal.hidden && !picker.open && !busy) renderCards(); };
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', applyResponsiveCardLimit);
  else mobileQuery.addListener(applyResponsiveCardLimit);
  async function refresh() {
    const version = ++generation;
    grid.replaceChildren(); grid.hidden = false; rotateButton.disabled = true;
    status.textContent = 'Hämtar förslag utifrån din varukorg och aktuellt lager…';
    try {
      const freshCart = await readCart();
      if (version !== generation || modal.hidden) return;
      cart = freshCart; lastSignature = signature(cart);
      if (skipSignature === lastSignature) { close(false); proceed(); return; }
      await loader.prepare(cart, {seed, previous, onProgress: (found, done, info) => {
        if (version !== generation || modal.hidden) return;
        products = found;
        moreSuggestions = info.hasMore;
        // Keep keyboard focus and an open variant picker stable as later batches arrive.
        if (!picker.open && !busy && !grid.contains(document.activeElement)) renderCards();
        if (!busy && (products.length || done)) status.textContent = products.length ? 'Förslag till ditt projekt. Kontrollera alltid storlek och längd mot mönstret.' : 'Inga fler lagerförda tillbehör kunde matchas just nu. Du kan fortsätta till kassan.';
      }});
      if (version !== generation || modal.hidden) return;
      status.textContent = products.length ? 'Förslag till ditt projekt. Kontrollera alltid storlek och längd mot mönstret.' : 'Inga fler lagerförda tillbehör kunde matchas just nu. Du kan fortsätta till kassan.';
    } catch (_) {
      if (version === generation && !modal.hidden) status.textContent = 'Förslagen kunde inte hämtas. Du kan fortsätta till kassan som vanligt.';
    } finally { if (version === generation && !busy) rotateButton.disabled = false; }
  }
  function close(markSkipped = true) {
    if (busy) return;
    if (picker.open) picker.close();
    ++generation;
    if (markSkipped) skipSignature = lastSignature;
    modal.hidden = true; modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pre-checkout-upsell-open');
    window.removeTrapFocus?.(opener);
    const drawer = document.querySelector('cart-drawer.active');
    if (drawer) window.trapFocus?.(drawer, opener?.isConnected ? opener : drawer.querySelector('button'));
    else if (opener?.isConnected) opener.focus({preventScroll: true});
  }
  function proceed() {
    if (busy) return;
    close(false);
    // Do not POST stale cart form quantities after adding accessories.
    if (window.KickisBackorder) window.KickisBackorder.checkout();
    else location.assign(`${root}checkout`);
  }
  function open(button) {
    if (!modal.hidden) return;
    opener = button; uncertain = false; lastSignature = ''; impressions.clear();
    modal.hidden = false; modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pre-checkout-upsell-open');
    window.trapFocus?.(modal, continueButton);
    continueButton.focus({preventScroll: true});
    refresh();
  }
  function intercept(event, button) {
    if (!button || button.disabled || button.dataset.preCheckoutBypass === 'true') return;
    if (button.form && !button.form.reportValidity()) { event.preventDefault(); return; }
    event.preventDefault(); event.stopImmediatePropagation(); open(button);
  }
  document.addEventListener('click', e => intercept(e, e.target.closest(checkoutSelector)), true);
  document.addEventListener('submit', e => { if (e.submitter?.matches(checkoutSelector)) intercept(e, e.submitter); }, true);
  modal.querySelectorAll('[data-upsell-close], [data-upsell-overlay]').forEach(b => b.addEventListener('click', () => close()));
  continueButton.addEventListener('click', proceed);
  rotateButton.addEventListener('click', () => { if (busy || uncertain) return; skipSignature = ''; seed = Math.floor(Math.random() * 1e9); refresh(); });
  document.addEventListener('keydown', e => {
    if (modal.hidden || e.key !== 'Escape') return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (picker.open) { if (!busy) picker.close(); } else close();
  }, true);
  function renderOptions() {
    const query = pickerSearch.value.toLocaleLowerCase('sv').trim();
    const matches = currentProduct.variants.filter(v => v.title.toLocaleLowerCase('sv').includes(query));
    pickerList.innerHTML = matches.slice(0, shownOptions).map(v => `<div class="upsell-option">
      <label><input type="checkbox" data-variant="${v.id}" ${selected.has(String(v.id)) ? 'checked' : ''}>
      ${v.image ? `<img src="${escape(safeImage(v.image))}" alt="" width="44" height="44" loading="lazy">` : ''}
      <span>${escape(v.title === 'Default Title' ? currentProduct.title : v.title)}<small>${money(v.price * (currentProduct.cm ? 100 : 1))}${currentProduct.cm ? ' / m' : ''}</small></span></label>
      <label class="upsell-option-quantity">${currentProduct.cm ? 'Meter' : 'Antal'}<input type="number" data-quantity="${v.id}" aria-label="${currentProduct.cm ? 'Meter' : 'Antal'} ${escape(v.title)}" min="${v.min / (currentProduct.cm ? 100 : 1)}" step="${v.step / (currentProduct.cm ? 100 : 1)}" ${v.max ? `max="${v.max / (currentProduct.cm ? 100 : 1)}"` : ''} value="${(selected.get(String(v.id)) || v.min) / (currentProduct.cm ? 100 : 1)}"></label></div>`).join('');
    picker.querySelector('[data-upsell-more]').hidden = matches.length <= shownOptions;
    pickerStatus.textContent = `${matches.length} tillgängliga alternativ. ${selected.size} valda.`;
    pickerAdd.disabled = !selected.size || busy || uncertain;
  }
  function choose(p, button) {
    if (busy || uncertain) return;
    analytics('upsell_clicked', p);
    if (p.variantCount === 1) { add(p, new Map([[String(p.variants[0].id), p.variants[0].min]])); return; }
    currentProduct = p; selected = new Map(); shownOptions = 40; pickerOpener = button;
    pickerSearch.value = ''; picker.querySelector('h3').textContent = p.title;
    picker.querySelector('[data-upsell-picker-reason]').textContent = p.reason;
    picker.querySelector('[data-upsell-product-link]').href = url(p);
    renderOptions(); window.removeTrapFocus?.(); picker.showModal(); pickerSearch.focus();
  }
  grid.addEventListener('click', e => {
    const card = e.target.closest('[data-upsell-card]');
    if (!card) return;
    const p = products.find(p => p.handle === card.dataset.handle);
    if (e.target.closest('[data-upsell-choose]')) choose(p, e.target.closest('button'));
    else if (e.target.closest('a')) analytics('upsell_clicked', p);
  });
  pickerSearch.addEventListener('input', () => { shownOptions = 40; renderOptions(); });
  picker.querySelector('[data-upsell-more]').addEventListener('click', () => { shownOptions += 40; renderOptions(); });
  pickerList.addEventListener('change', e => {
    const row = e.target.closest('.upsell-option'); if (!row) return;
    const checkbox = row.querySelector('[data-variant]'), quantity = row.querySelector('[data-quantity]');
    const count = Number(quantity.value) * (currentProduct.cm ? 100 : 1);
    if (!quantity.reportValidity() || !Number.isSafeInteger(Math.round(count)) || Math.abs(count - Math.round(count)) > 1e-7) return;
    if (checkbox.checked) selected.set(checkbox.dataset.variant, Math.round(count)); else selected.delete(checkbox.dataset.variant);
    pickerStatus.textContent = `${selected.size} alternativ valda.`; pickerAdd.disabled = !selected.size || uncertain;
  });
  picker.querySelector('[data-upsell-picker-close]').addEventListener('click', () => { if (!busy) picker.close(); });
  picker.addEventListener('cancel', e => { if (busy) e.preventDefault(); });
  picker.addEventListener('close', () => { if (!modal.hidden) window.trapFocus?.(modal, pickerOpener?.isConnected ? pickerOpener : continueButton); });
  pickerAdd.addEventListener('click', () => {
    if (![...pickerList.querySelectorAll('input[type="number"]')].every(i => i.reportValidity())) return;
    // Capture the currently focused quantity too; a click must not use an older saved value.
    pickerList.querySelectorAll('.upsell-option').forEach(row => {
      const checkbox = row.querySelector('[data-variant]');
      if (checkbox.checked) selected.set(checkbox.dataset.variant, Math.round(Number(row.querySelector('[data-quantity]').value) * (currentProduct.cm ? 100 : 1)));
    });
    add(currentProduct, new Map(selected));
  });
  async function add(p, selections) {
    if (busy || uncertain || !selections.size) return;
    setBusy(true); status.textContent = pickerStatus.textContent = 'Kontrollerar lager och lägger till…';
    let posted = false;
    try {
      const [live, freshCart] = await Promise.all([detail(p), json(`${root}cart.js`)]);
      const memberIds = new Set([String(p.id), ...(live.variants || []).map(v => String(v.productId))]);
      if (engine.cartLines(freshCart).some(l => memberIds.has(String(l.product_id)))) throw Error('Produkten finns redan i varukorgen. Ändra antal där i stället.');
      const valid = engine.eligible(p, live)?.variants || [];
      const items = [...selections].map(([id, quantity]) => {
        const v = valid.find(v => String(v.id) === id);
        if (!v || !Number.isSafeInteger(quantity) || quantity < v.min || quantity % v.step || v.max && quantity > v.max) throw Error('Ett valt alternativ är inte längre tillgängligt. Öppna förslagen igen.');
        return {id: Number(id), quantity, properties: {'_Kickis-källa': 'pre_checkout'}};
      });
      posted = true;
      const result = await json(window.routes?.cart_add_url || `${root}cart/add.js`, {method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({items, sections: ['cart-icon-bubble'], sections_url: root})});
      const icon = document.getElementById('cart-icon-bubble');
      if (icon && result.sections?.['cart-icon-bubble']) icon.innerHTML = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section')?.innerHTML || icon.innerHTML;
      items.forEach(item => analytics('upsell_added', p, valid.find(v => v.id === item.id), item.quantity));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'pre-checkout-upsell', cartData: result});
      cart = await json(`${root}cart.js`); lastSignature = signature(cart);
      selected.clear(); if (picker.open) picker.close();
      loader.clearStock(); products = []; grid.replaceChildren();
      // The cart write is confirmed. Refresh suggestions without holding checkout disabled.
      setBusy(false);
      const refreshedGeneration = generation + 1;
      refresh().then(() => {
        if (generation === refreshedGeneration && !busy && !modal.hidden) status.textContent = `${p.title} har lagts i varukorgen.`;
      });
      status.textContent = `${p.title} har lagts i varukorgen.`; continueButton.focus();
    } catch (error) {
      // A timed-out/partial cart request must never be automatically retried.
      uncertain = posted;
      status.textContent = pickerStatus.textContent = posted ? 'Kontrollera varukorgen innan du försöker igen – tillägget kunde inte bekräftas. Fortsätt handla för att granska korgen.' : error.message;
      if (posted && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'pre-checkout-upsell'});
    } finally { setBusy(false); }
  }
})();
